module.exports = __webpack_public_path__ + "static/img/swd.43c02674.png";